import { z } from 'zod'
import { isValidCPF } from '@/shared/utils/validate-cpf'

// Regex para validação de CPF formatado (XXX.XXX.XXX-XX)
const cpfFormattedRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/

/**
 * Schema Zod para CPF formatado (XXX.XXX.XXX-XX)
 * Valida formato e dígitos verificadores
 */
export const cpfSchema = z
  .string()
  .min(14, 'CPF deve ter 11 dígitos')
  .max(14, 'CPF deve ter 11 dígitos')
  .refine((val) => cpfFormattedRegex.test(val), {
    message: 'CPF deve estar no formato XXX.XXX.XXX-XX',
  })
  .refine((val) => isValidCPF(val), {
    message: 'CPF inválido',
  })

/**
 * Schema Zod para CPF opcional (permite vazio)
 */
export const optionalCpfSchema = z
  .string()
  .refine(
    (val) => {
      if (!val || val === '') return true

      return cpfFormattedRegex.test(val) && isValidCPF(val)
    },
    { message: 'CPF inválido' },
  )
  .optional()
  .or(z.literal(''))

/**
 * Schema Zod para CPF não formatado (apenas dígitos)
 * Útil para enviar ao backend
 */
export const cpfRawSchema = z
  .string()
  .length(11, 'CPF deve ter 11 dígitos')
  .regex(/^\d{11}$/, 'CPF deve conter apenas números')
  .refine((val) => isValidCPF(val), {
    message: 'CPF inválido',
  })
